<script setup>
  import {computed, inject} from "vue";

  import {Link as InertiaLink, usePage} from "@inertiajs/vue3";
  import {MedIcon} from "@pharma4u/medicheck-components";
  import {cn} from "@pharma4u/medicheck-components/utils";

  defineOptions({
    name: "AuthHeaderNavItem",
  });

  const props = defineProps({
    label: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    href: {
      type: String,
      default: null,
    },
  });

  const dropdownContext = inject("authDropdownContext", {isOpen: false});

  const page = usePage();

  const isActive = computed(() => {
    if (props.href) {
      return props.href.includes(page.url.split("?")[0]);
    } else {
      return false;
    }
  });
</script>

<template>
  <component
    :is="href ? InertiaLink : 'button'"
    :href="href"
    :class="
      cn(
        'inline-flex h-16 items-center gap-2 px-1 pt-1',
        'border-l-2 md:border-b-2 md:border-l-0',
        'font-semibold text-gray-500',
        'med-outset-focus cursor-pointer hover:border-gray-300 hover:text-gray-900',
        {'border-mcred': isActive, 'border-transparent': !isActive},
      )
    "
    :data-test="getTestId('nav-item' + (href ? '-link' : '-button'))"
  >
    {{ label }}

    <template v-if="icon">
      <MedIcon
        :icon="icon"
        :class="
          cn('transition-transform duration-200', {
            'rotate-180': dropdownContext.isOpen.value,
          })
        "
      />
    </template>
  </component>
</template>
